import * as React from 'react';
import { Grid, Avatar, IconButton } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

import { UploadResponse, UploadScenarios } from 'interfaces/file-uploader';
import './index.scss';
import { EditIcon } from 'assets/icons';
import useFileUpload from 'base/core/hooks/use-file-upload';
import useConfirmation from 'base/common/confirm-modal/confirmation-hook';
import { IconLoadingButton } from '../custom-button';

interface FileUploaderProps {
  handleFile: (res: UploadResponse) => void,
  currentImageUrl: string,
  scenario: UploadScenarios,
  sx: SxProps<Theme>,
  alt: string,
}

const AvatarUploader = ({
  handleFile, currentImageUrl, scenario, sx, alt,
}: FileUploaderProps) => {
  const [uploading, setUploading] = React.useState(false);
  const [imageUrl, setImageUrl] = React.useState(currentImageUrl);
  const hiddenFileInput: any = React.useRef(null);
  const { progress, handleContentDataUpload } = useFileUpload();
  const confirm = useConfirmation();

  // triggers the native input file button on click
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = async (event: any) => {
    setUploading(true);

    const res = await handleContentDataUpload(
      event,
      currentImageUrl,
      scenario,
    );
    if (res.statusCode >= 200 && res.statusCode < 300) {
      setTimeout(() => {
        setImageUrl(res.url);
        handleFile(res);
        setUploading(false);
      }, 3000);
    } else {
      confirm({
        variant: 'info',
        icon: 'error',
        message: res?.message ?? 'Unkown error!',
        confirmButtonTxt: 'Ok',
      });
      setUploading(false);
    }
  };

  React.useEffect(() => {
    setImageUrl(currentImageUrl);
  }, [currentImageUrl]);

  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <Grid item xs="auto" className="grid-item">
        <input
          ref={hiddenFileInput}
          accept="image/*"
          type="file"
          style={{
            display: 'none',
          }}
          onChange={handleChange}
        />
        <IconButton color="primary" aria-label="upload picture" component="span" className="avatar-uploader-wrapper" onClick={handleClick}>
          <Avatar alt={alt} sx={sx} src={imageUrl} />
          <div className="overlay">
            {uploading && <IconLoadingButton sx={{ mx: 'auto', mt: '13px' }} loading />}
            {!uploading && <EditIcon sx={{ color: '#fff', fontSize: '20px' }} />}
          </div>
        </IconButton>
      </Grid>
    </Grid>
  );
};
export default AvatarUploader;
